<template>
  <div v-loading="isBusy">
    <h2>お問い合わせの確認</h2>

    <v-subheader id="value-list-container">入力に間違いがないか、ご確認ください</v-subheader>
    <el-row  style="display:flex; justify-content:center;">
      <el-col :span="15">
        <value-list></value-list>
      </el-col>
    </el-row>
    <div style="display:flex; justify-content:center;">
      <v-btn color="blue" @click="handleClickSubmit()">送信する</v-btn>
      <v-btn class="centered" style="margin-left: 170px;" to="/">戻る</v-btn>
    </div>

  </div>
</template>


<script>
import store from "../../store";
import { api } from "../../services";
import ValueList from "./ValueList.vue";

export default {
  components: {
    ValueList
  },

  created: function () {
    this.$store.commit("contact/stepActive", 1);
  },

  /**
   * ルートが遷移する前に呼び出される関数
   * @param {*} to 遷移先のルートオブジェクト
   * @param {*} from 遷移元のルートオブジェクト
   * @param {*} next ルート遷移が許可されるために呼び出される必要があるコールバック関数
   */
  beforeRouteEnter(to, from, next) {
    //値が存在しないときはフォーム画面に戻す
    if (store.getters["contact/isEmpty"]) {
      next("/contact");
    }
    next();
  },

  data() {
    return {
      isBusy: false
    };
  },
  computed: {
    product() {
      return this.$store.getters["contact/product"];
    },
    values() {
      return this.$store.getters["contact/values"];
    }
  },

  methods: {
    /**
     * サーバーにリクエスト送信
     */
    async handleClickSubmit() {
      this.isBusy = true;

      //入力データをPOSTリクエスト
      let result = await api.fetchPosts(this.values);

      this.isBusy = false;

      if (result === null) {
        this.$message({
          showClose: true,
          message: "送信エラーが起きました。",
          type: "error"
        });
      } else {
        this.$router.push("/result");
      }
    }
  }
};
</script>
<style>
#value-list-container {
  text-align: center !important;
  display: block;
  height: auto;
}

h2 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>